module.exports = __webpack_public_path__ + "static/img/wangye.65503ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/wangye.png
// module id = XJKL
// module chunks = 10